module.exports = __webpack_public_path__ + "static/img/ic3.db34224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic3.png
// module id = UZez
// module chunks = 1